import { lazy, Suspense } from 'react';
import { Outlet, RouteObject } from 'react-router';
import { Layout as DashboardLayout } from 'src/layouts/dashboard';
import { OrganizationGuard } from './OrganizationGuard';
import OrganizationSetting from 'src/pages/settings/organization';
import ProcessModuleList from 'src/pages/settings/form-builder/ProcessModuleList';
import ModuleFormList from 'src/pages/settings/form-builder/ModuleFormList';
import FormBuilderPage from 'src/pages/modules/process-module/FormBuilderPage';
const FieldList = lazy(() => import('src/pages/settings/form-builder/FieldList'));
const ProcessModuleBuilder = lazy(() => import('src/pages/modules/process-module/ProcessModuleBuilder'));

export const organizationRoutes: RouteObject[] = [
  {
    path: 'o',
    element: (
      <DashboardLayout>
        <OrganizationGuard>
          <Suspense>
            <Outlet />
          </Suspense>
        </OrganizationGuard>
      </DashboardLayout>
    ),
    children: [
      {
        path: ':organizationId',
        children: [
          {
            path: 'settings',
            element: <OrganizationSetting></OrganizationSetting>,
          },
          {
            path: 'form-builder',
            children: [
              {
                path: 'fields',
                element: (
                  <Suspense>
                    <FieldList />
                  </Suspense>
                ),
              },
              {
                path: 'modules',
                element: <ProcessModuleList />,
              },
              {
                path: 'modules/new',
                element: (
                  <Suspense>
                    <ProcessModuleBuilder />
                  </Suspense>
                ),
              },
              {
                path: 'modules/:moduleId/edit',
                element: (
                  <Suspense>
                    <ProcessModuleBuilder />
                  </Suspense>
                ),
              },
              {
                path: 'modules/:moduleId/forms',
                element: <ModuleFormList />,
              },
              {
                path: 'modules/:moduleId/forms/:formId/edit',
                element: <FormBuilderPage />,
              },
            ],
          },
        ],
      },
    ],
  },
];
